var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"max-width":"1000","dark":"","color":"secondary"}},[_c('v-card-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-alert-circle-outline ")]),_vm._v("\n    You are being redirected.\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }